import React from "react";
import { useTranslation } from "react-i18next";

interface SLABreachedProps {
  sLABreached?: boolean;
}

const SLABreached: React.FC<SLABreachedProps> = ({ sLABreached }) => {
  const { t } = useTranslation(["common", "registration"]);

  return (
    <div className="sla-status d-flex align-items-center">
      {t("sLABreached")}
      <span>
        {sLABreached ? (
          <div className="d-flex gap-1 align-items-center">
            <span className="oval red-oval">{t("exceeded")}</span>
          </div>
        ) : (
          <div className="d-flex gap-1 align-items-center">
            <span className="oval blue-oval">{t("onTrack")}</span>
          </div>
        )}
      </span>
    </div>
  );
};

export default SLABreached;
